var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Angola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d8241b",
    d: "M24,4C12.974,4,4.034,12.924,4.003,23.943h39.994C43.966,12.924,35.026,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f1916",
    d: "M44,24c0-0.019-0.003-0.038-0.003-0.057H4.003C4.003,23.962,4,23.981,4,24c0,11.046,8.954,20,20,20 S44,35.046,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M22.922,19l0.598-1.828L24.098,19H26l-1.523,1.184l0.637,1.902L23.5,20.883l-1.574,1.203l0.633-1.887 L21,19H22.922z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M20.441,22.242c-1.719,3.617,1.629,3.844,8.16,8.621l0.539-0.629l-6.469-5.023 c-0.043-0.031-0.023-0.102,0.027-0.102c0.016,0,0.027,0.004,0.039,0.012l6.477,5.031l0.102-0.117 C21.719,24.219,20.836,23.641,20.441,22.242z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M29.492,30.18l-0.598,0.75l1.906,1.461c0.246,0.703,0.777,0.727,1.082,0.426 c0.137-0.137,0.184-0.563-0.063-0.762L29.492,30.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M30.199,31.391c0.047,0,0.086,0.039,0.086,0.09c0,0.047-0.039,0.086-0.086,0.086 s-0.086-0.039-0.086-0.086C30.113,31.43,30.152,31.391,30.199,31.391z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M30.668,31.746c0.051,0,0.09,0.039,0.09,0.09s-0.039,0.09-0.09,0.09c-0.047,0-0.086-0.039-0.086-0.09 S30.621,31.746,30.668,31.746z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M30.992,31.688c0.047,0,0.082,0.039,0.082,0.086c0,0.051-0.035,0.09-0.082,0.09 s-0.086-0.039-0.086-0.09C30.906,31.727,30.945,31.688,30.992,31.688z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M25.176,29.73c-0.43-0.277-0.832-0.531-1.215-0.77c-2.066,0.605-4.332,0.191-6.066-1.215 l-0.691,0.887c0.301,0.242,0.609,0.457,0.934,0.648L17.93,29.98l1.219,0.543l0.305-0.617c0.441,0.16,0.895,0.277,1.352,0.355 l0.074,0.762l1.336,0.027l0.047-0.684c0.496-0.008,0.992-0.066,1.477-0.172l0.316,0.695l1.266-0.422l-0.188-0.719 C25.148,29.742,25.16,29.734,25.176,29.73z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d418",
    d: "M28.73,21.336c0.332,2.098-0.32,4.188-1.691,5.699c0.277,0.211,0.57,0.438,0.875,0.668 c0.246-0.277,0.488-0.559,0.691-0.867l0.75,0.242l0.551-1.234l-0.602-0.324c0.199-0.469,0.348-0.965,0.453-1.469l0.781-0.035 l0.098-1.355l-0.711-0.094c0.008-0.465-0.027-0.938-0.102-1.41c-0.012-0.07-0.023-0.145-0.039-0.215l0.684-0.309l-0.395-1.297 l-0.695,0.176c-0.242-0.621-0.559-1.207-0.938-1.742l0.508-0.543l-0.848-1.051l-0.629,0.477c-0.355-0.344-0.742-0.648-1.156-0.918 l0.273-0.723l-1.184-0.629l-0.387,0.668c-0.422-0.172-0.859-0.309-1.313-0.402l-0.227,1.105 C26.203,16.336,28.285,18.555,28.73,21.336z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Angola);
export default __webpack_public_path__ + "static/media/icons8-angola.f51cf71025ed084250510e15c1af5199.svg";
export { ForwardRef as ReactComponent };